// Sessão do operador + contexto de clínica/unidade — API real.
// Cutover Fatia 1: fala com /clinica/session e /clinica/badges do safetycare-api
// e adapta o payload canônico (memberships) para o shape que o Vuex e as views
// consomem (operator/clinics/units). Campos de apresentação (initials, role
// label) são derivados AQUI — não pertencem à API.
import AXIOS from "@/services/axios";

function initialsOf(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0])
    .join("")
    .toUpperCase();
}

// Backend usa enum admin|attendant; o front fala admin|atendimento.
function displayRole(roles) {
  return (roles || []).includes("admin") ? "admin" : "atendimento";
}

function clinicRole(role) {
  return role === "admin" ? "admin" : "atendimento";
}

function adaptSession(session) {
  const memberships = session.memberships || [];
  const role = displayRole(session.roles);
  const isAdmin = role === "admin";
  const first = memberships[0];

  // Papel e permissões valem por clínica (US-C11): o store usa os da ativa.
  const clinics = memberships.map(m => ({
    id: m.institution.id,
    name: m.institution.name,
    unitIds: (m.institution.units || []).map(u => u.id),
    role: clinicRole(m.role),
    permissions: m.permissions || {}
  }));

  const units = [];
  const seen = new Set();
  memberships.forEach(m => {
    (m.institution.units || []).forEach(u => {
      if (seen.has(u.id)) return;
      seen.add(u.id);
      units.push({
        id: u.id,
        name: u.name,
        clinicId: m.institution.id,
        doctorCount: u.doctor_count || 0,
        address: ""
      });
    });
  });

  const operator = {
    id: session.id,
    name: session.name,
    email: session.email,
    initials: initialsOf(session.name),
    role,
    roleLabel: isAdmin ? "Administrador" : "Atendimento",
    clinicStaff: !!session.clinic_staff,
    clinicId: first ? first.institution.id : null,
    clinicName: first ? first.institution.name : null,
    unitId: units[0] ? units[0].id : null,
    status: "ativo"
  };

  return { operator, clinics, units };
}

export class ClinicSession {
  /** Sessão do operador logado + clínicas/unidades onde tem membership. */
  static session() {
    return AXIOS.get("clinica/session").then(res => ({
      data: adaptSession(res.data)
    }));
  }

  /** Badges ao vivo da sidebar (contagens já vêm prontas do backend). */
  static badges() {
    return AXIOS.get("clinica/badges");
  }
}

export default ClinicSession;
